import { useState, useEffect } from "react";

import { db } from "../../util/firebase";
import { query, collection, getDocs } from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { useTranslation } from "react-i18next";

function NewsPage() {
  const { t } = useTranslation("common");

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const [mainNewsArticle, setMainNewsArticle] = useState();
  const [secondaryNewsArticles, setSecondaryNewsArticles] = useState();
  const fetchNewsArticles = async () => {
    try {
      setIsLoading(true);

      let fetchedMainArticle;
      let fetchedSecondaryArticles = [];

      const q = query(collection(db, "newsArticles"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newArticle = doc.data();
        if (newArticle.type === "main") {
          fetchedMainArticle = newArticle;
        } else {
          fetchedSecondaryArticles.push(newArticle);
        }
      });

      setMainNewsArticle(fetchedMainArticle);
      setSecondaryNewsArticles(fetchedSecondaryArticles);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching news articles");
    }
  };
  useEffect(() => {
    fetchNewsArticles();
    // eslint-disable-next-line
  }, []);

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsPage" className="page">
      <h1>{t("whatsNew").toUpperCase()}</h1>
      <div>
        <div id="newsPageMainNewsContainer">
          <div
            onClick={() => navigate(`/news/articles/${mainNewsArticle.uid}`)}
            id="newsPageMainNewsArticle"
          >
            <img
              alt="newsArticleImage"
              src={
                mainNewsArticle?.image
                  ? mainNewsArticle?.image
                  : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
              }
            />
            <p className="articleTitle">{mainNewsArticle?.title}</p>
            <p>
              <span style={{ fontWeight: 500 }}>
                {new Date(mainNewsArticle?.dateCreated).toLocaleDateString(
                  "de-DE"
                )}
              </span>
            </p>
            <p>{mainNewsArticle?.text}</p>
          </div>
          <div id="newsPagePrimaryNewsContainer">
            {secondaryNewsArticles?.map((secondaryNewsArticle) => {
              return (
                <div
                  onClick={() =>
                    navigate(`/news/articles/${secondaryNewsArticle.uid}`)
                  }
                  className="newsPagePrimaryNewsArticle"
                >
                  <img
                    alt="newsArticleImage"
                    src={
                      secondaryNewsArticle?.imageSecondary
                        ? secondaryNewsArticle?.imageSecondary
                        : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                    }
                  />
                  <div>
                    <p className="articleTitle">
                      {secondaryNewsArticle?.title}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {/* <div id='newsPageSecondaryNewsContainer'>
          {
            secondaryNewsArticles?.map(secondaryNewsArticle => {
              return (
                <div onClick={() => navigate(`/news/articles/${secondaryNewsArticle.uid}`)} className='newsPageSecondaryNewsArticle'>
                  <img
                    alt="newsArticleImage"
                    src={secondaryNewsArticle?.image ? secondaryNewsArticle?.image : 'https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3'}
                  />
                  <p className='articleTitle'>
                    {secondaryNewsArticle?.title}
                  </p>
                </div>
              )
            })
          }
        </div> */}
      </div>
    </div>
  );
}

export default NewsPage;
